namespace TabAurous.Common {
    export enum MarkUpType {
        Component = 1,
        Labor = 2
    }
    Serenity.Decorators.registerEnumType(MarkUpType, 'TabAurous.Common.MarkUpType', 'Administration.MarkUpType');
}
